import RescueVehicleCodeModalContainer from './RescueVehicleCodeModalContainer'

export default RescueVehicleCodeModalContainer
